import './footer-c.scss';
import { execOnLoad } from '@general/helpers';
import breakpoints from 'breakpoints';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initFooter = (context) => {
  const footerContainer = context.classList.contains('.mobile-menu__container')
    ? context
    : context.closest('.footer-c__container');
  if (!footerContainer) return;

  const topButton = footerContainer.querySelector('.footer-c__top-button');

  topButton?.addEventListener('click', () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });

  const lgUp = window.matchMedia(`(min-width: ${breakpoints.lg})`);
  const handleMenu = () => {
    const footerMenus = footerContainer.querySelectorAll(
      'details.footer-c__menu-group',
    );
    if (lgUp.matches && footerMenus) {
      footerMenus.forEach((menu) => menu.setAttribute('open', ''));
    } else {
      footerMenus.forEach((menu) => menu.removeAttribute('open'));
    }
  };

  handleMenu();
  lgUp.addEventListener('change', handleMenu);
};

execOnLoad(window.dAgency.initFooter, '.footer-c__container');
